// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__vXc+U","card":"Contact_card__B2JS6","card2":"Contact_card2__5Sd+U","icons":"Contact_icons__3gyqN","section":"Contact_section__vtO-c"};